import { HttpErrorResponse } from '@angular/common/http';
import { Injector, ResourceRef } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { OrbitUtils } from '../../../../../../global/orbit/orbit-utils';

export function getErrorsFromSubmission<T = any>(
  submissionResource: ResourceRef<T>,
  injector: Injector,
  callback: (attempts: number, error: Record<string, any> | undefined) => void,
  options: Partial<{
    autoRetry: boolean;
    maxNumberOfAttempts: number;
    endpointStatusChange: () => void;
  }> = {
    autoRetry: true,
    maxNumberOfAttempts: 3,
  }
) {
  let attempts = 0;

  toObservable(submissionResource.value, { injector }).subscribe({
    next: () => {
      attempts = 0;
    },
  });

  toObservable(submissionResource.status, { injector }).subscribe({
    next: () => {
      if (options.endpointStatusChange) {
        options.endpointStatusChange();
      }
    },
  });

  toObservable<HttpErrorResponse>(submissionResource.error as any, { injector }).subscribe({
    next: (val: HttpErrorResponse) => {
      if (val == undefined) return;

      attempts = attempts + 1;

      if (attempts >= options.maxNumberOfAttempts!) {
        console.error('Max attempts reached for error handling');
        OrbitUtils.sendUserToErrorPage(val);
        callback(attempts, val?.error);
        return;
      }

      const response = val?.error?.target?.response || val?.error;
      callback(attempts, response);

      if (!options.autoRetry) return;
      if (!response?.allowRetry) {
        OrbitUtils.sendUserToErrorPage(val);
        return;
      }

      if (options.autoRetry && response?.allowRetry) {
        submissionResource.reload();
      }
    },
  });
}
